import documentsApiService from '@/services/api/Documents'

const STATUS_DRAFT = 'draft'
const STATUS_FINAL = 'final'

const STATUS_DATA = {
  [STATUS_DRAFT]: {
    color: 'grey',
    label: 'Draft'
  },
  [STATUS_FINAL]: {
    color: 'success',
    label: 'Final'
  }
}

export default class Document {
  static api = documentsApiService

  static STATUS_DRAFT = STATUS_DRAFT
  static STATUS_FINAL = STATUS_FINAL

  static statusData = STATUS_DATA
}
